export default "__VITE_ASSET__c4ff5c5b__"